import { dateTime } from '@/_shared';

export const ACH_CAMPAIGN_SAVING_AMOUNT = 200;
export const ACH_CAMPAIGN_END_DATE = dateTime.parse('31-07-2024', 'DD-MM-YYYY');
